import { useState, useEffect } from "react";
import { Budget, fetchBudget } from "../queries/getBudget";

export const useFetchBudgetQuery = ({ budgetId }: { budgetId: number | null }) => {
  const [budget, setBudget] = useState<Budget | null>(null);

  useEffect(() => {
    if (budgetId) {
      fetchBudget(budgetId)
        .then((budget) => {
          setBudget(budget);
        })
        .catch((error: unknown) => {
          console.error(error);
          setBudget(null);
        });
    }
  }, [budgetId]);

  return { budget };
};
